module.exports = __webpack_public_path__ + "static/media/scores_10000.3af179a7.png";